import React, { useEffect, useState } from 'react';
import { Box, Button, Autocomplete, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import dayjs from 'dayjs';
import { Sec, Box as CardBox, Filters } from '../styled';
import DateRangePickerML from '@/components/DateRangePickerML';

// 查询区
// - 剧目名称：单选下拉（Autocomplete，本地搜索，按 proNo 选中）
// - 时间范围：DateRangePickerML，最长 90 天（约 3 个月）
// 受控：查询条件存于 performSales store；本组件内部 useState 镜像并双向同步
const PageHeader = ({
  proNo,
  dateStart,
  dateEnd,
  playList = [],
  setProNo,
  setDateStart,
  setDateEnd,
  onSearch,
  onReset,
}) => {
  const today = dayjs().format('YYYY-MM-DD');
  const threeMonthsAgo = dayjs().subtract(89, 'day').format('YYYY-MM-DD');

  const [play, setPlay] = useState(null);
  const [dateRange, setDateRange] = useState([
    dateStart || threeMonthsAgo,
    dateEnd || today,
  ]);
  // 重置信号：触发 DateRangePickerML 的 isResetDefalut 把内部 state 恢复到 resetStartDate/resetEndDate
  // const [resetSignal, setResetSignal] = useState(0);

  // 外部 store 变化时回填到本地 state
  useEffect(() => {
    const found = (playList || []).find((p) => p.proNo === proNo) || null;
    setPlay(found);
  }, [proNo, playList]);

  useEffect(() => {
    if (dateStart && dateEnd) {
      setDateRange([dateStart, dateEnd]);
    } else {
      setDateRange([threeMonthsAgo, today]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateStart, dateEnd]);

  const handleSubmit = () => {
    const [s, e] = dateRange || [];
    if (play) {
      setProNo && setProNo(play.proNo);
    }

    if (setDateStart && setDateEnd) {
      setDateStart(s);
      setDateEnd(e);
      onSearch();
    }
  };

  const handleResetClick = () => {
    setPlay(playList[0]);
    setDateRange([threeMonthsAgo, today]);
    // setResetSignal((n) => n + 1);
    onReset && onReset();
  };

  return (
    <Sec>
      <CardBox>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Filters>
            <Autocomplete
              options={playList}
              value={play}
              onChange={(_, v) => setPlay(v)}
              getOptionLabel={(o) => (o ? `${o.proName} 编号${o.proNo}` : '')}
              isOptionEqualToValue={(o, v) => o?.proNo === v?.proNo}
              filterOptions={(opts, state) => {
                const q = (state.inputValue || '').trim().toLowerCase();
                if (!q) {
                  return opts;
                }
                return opts.filter(
                  (o) =>
                    (o.proName || '').toLowerCase().includes(q) ||
                    (o.proNo || '').toLowerCase().includes(q),
                );
              }}
              disableClearable
              noOptionsText="无匹配剧目"
              style={{ minWidth: 280 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="剧目名称"
                  variant="standard"
                  placeholder="请选择剧目"
                />
              )}
            />

            <DateRangePickerML
              startText="开始时间"
              endText="结束时间"
              defaultStartDate={dateRange?.[0] || threeMonthsAgo}
              defaultEndDate={dateRange?.[1] || today}
              // afterDays={89}
              resetStartDate={threeMonthsAgo}
              resetEndDate={today}
              isReset={false}
              // isResetDefalut={resetSignal > 0}
              onChange={(v) => {
                if (v && v.reset === false) {
                  setDateRange([v.startDate, v.endDate]);
                }
              }}
            />

            <Box style={{ marginLeft: 'auto', display: 'flex', gap: 16 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleResetClick}
                startIcon={<ReplayIcon style={{ width: 16, height: 16 }} />}
              >
                重置
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<SearchIcon style={{ width: 16, height: 16 }} />}
              >
                查询
              </Button>
            </Box>
          </Filters>
        </form>
      </CardBox>
    </Sec>
  );
};

export default PageHeader;
